import { ISerialisedDocumentReference } from '@principle-theorem/shared';
import { IAccountCreditDimension } from '../dimensions/account-credit';
import { IPatientScopedFact, ITimestampedFact } from './common';
import { IInvoiceDimension } from '../dimensions/invoice';
import { IPracticeDimension } from '../dimensions/practice';
import { ITransactionDimension } from '../dimensions/transaction';
import { IBigQueryAssociatedTreatmentCategory } from '../dimensions/appointment';

export interface IAccountCreditEventFact
  extends IPatientScopedFact,
    ITimestampedFact {
  accountCreditRef: ISerialisedDocumentReference;
  accountCredit: IAccountCreditDimension;
  remaining: number;
  invoiceRef?: ISerialisedDocumentReference;
  practiceRef?: ISerialisedDocumentReference;
  transactionRefs: ISerialisedDocumentReference[];
  invoice?: IInvoiceDimension;
  practice?: IPracticeDimension;
  transactions: ITransactionDimension[];
  treatmentCategoryRef?: ISerialisedDocumentReference;
  treatmentCategory?: IBigQueryAssociatedTreatmentCategory;
}
